
    import Component from "vue-class-component";
    import FileUploaderBase from "@/components/FileUploaderBase";
    import VueFilePond from "vue-filepond";
    import FilePondPluginImagePreview from "filepond-plugin-image-preview";
    import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
    import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
    import filePondLocalization from "@/components/filePondLocalization";

    const FilePond = VueFilePond(FilePondPluginImagePreview, FilePondPluginFileValidateType);
    @Component({
        components: {
            FilePond,
        },
    })
    export default class ImageUploader extends FileUploaderBase {
        filePondLocalization = filePondLocalization;

        get labelIdle() {
            return `${this.$ls.Components_Files_Text_DragImageHereOr} <span class="filepond--label-action">${this.$ls.Components_Files_Link_Browse}</span>`;
        }
    }
